import { isEmpty } from 'lodash'

import { GTTRoute, GTTRouteStop, GTTRouteSegment, GTRoute, GTRouteStop } from 'gql/types.generated'
import { BOOLEAN } from 'utils/boolean'
import { IRouteFilters, TIdDuplet } from './routes.types'

const getOriginByStops = <T>(stops: T[]): T => {
  return stops[0]
}

const getDestinationByStops = <T>(stops: T[]): T => {
  return stops[stops.length - 1]
}

const getIntermediateStopsByStops = <T>(stops: T[]): T[] => {
  return stops.slice(1, stops.length - 1)
}

const findSegmentByOriginAndDestination = (
  segments: GTTRouteSegment[],
  origin: GTTRouteStop,
  destination: GTTRouteStop
): GTTRouteSegment | undefined => {
  return segments.find((segment): TSFixMe => {
    return segment.origin.id === origin.id && segment.destination.id === destination.id
  })
}

const getOriginsIdDestinationIdDuplet = (origins: GTTRouteStop[], destination: GTTRouteStop): TIdDuplet => {
  origins = origins || []
  return origins.map((origin): TSFixMe => {
    return [origin.id, destination?.id]
  })
}

export const getFilteredRoutes = (routes: GTTRoute[], filters: IRouteFilters): GTTRoute[] | undefined => {
  routes = routes || []
  return routes.filter((route): TSFixMe => {
    const filteredSegment = [filters.origin && filters.origin.id, filters.destination && filters.destination.id]
    let originsIdAndDestinationsIdDuplet: TIdDuplet = []
    route.stops.forEach((stop, index): TSFixMe => {
      if (index > 0) {
        originsIdAndDestinationsIdDuplet = [
          ...originsIdAndDestinationsIdDuplet,
          ...getOriginsIdDestinationIdDuplet(route.stops.slice(0, index), stop)
        ]
      }
    })
    const originIdAndDestinationIdDuplet = originsIdAndDestinationsIdDuplet.find((segment): TSFixMe => {
      return (
        (!filteredSegment[0] || filteredSegment[0] === segment[0]) &&
        (!filteredSegment[1] || filteredSegment[1] === segment[1])
      )
    })
    if (isEmpty(originIdAndDestinationIdDuplet)) {
      return false
    }
    if (
      !isEmpty(filters.serviceCode) &&
      isEmpty(route.services.find(({ code }): TSFixMe => code === filters.serviceCode))
    ) {
      return false
    }
    if (
      filters.onlyActiveServices === BOOLEAN.TRUE &&
      isEmpty(route.services.find(({ isActive }): TSFixMe => isActive))
    ) {
      return false
    }
    return true
  })
}

export const resolvers = {
  TRoute: {
    duration(route: GTTRoute): number | null {
      const segment = findSegmentByOriginAndDestination(
        route.segments,
        getOriginByStops(route.stops),
        getDestinationByStops(route.stops)
      )

      if (segment && segment.companyLineSpecs.length > 0) {
        const lineSpec = segment.companyLineSpecs[0]

        return lineSpec.duration || null
      }

      return null
    },
    distance(route: GTTRoute): number | null {
      const segment = findSegmentByOriginAndDestination(
        route.segments,
        getOriginByStops(route.stops),
        getDestinationByStops(route.stops)
      )

      if (segment && segment.companyLineSpecs.length > 0) {
        const lineSpec = segment.companyLineSpecs[0]

        return lineSpec.distance || null
      }

      return null
    },
    origin(route: GTTRoute): GTTRouteStop {
      return getOriginByStops(route.stops)
    },
    destination(route: GTTRoute): GTTRouteStop {
      return getDestinationByStops(route.stops)
    },
    intermediateStops(route: GTTRoute): GTTRouteStop[] {
      return getIntermediateStopsByStops(route.stops)
    }
  },
  RouteServiceRoute: {
    origin(route: GTRoute): GTRouteStop {
      return getOriginByStops(route.stops)
    },
    destination(route: GTRoute): GTRouteStop {
      return getDestinationByStops(route.stops)
    },
    intermediateStops(route: GTRoute): GTRouteStop[] {
      return getIntermediateStopsByStops(route.stops)
    }
  }
}
